const venueTemplate = require('../../templates').venueTemplate;
const roomTemplate = require('../../templates').roomTemplate;

const venueData = Object.assign({}, venueTemplate, {
	id: 'mysterie-kastellet',
	name: 'Mysterie Kastellet',
	website: 'https://www.mysteriekastellet.com',
	locations: [{
		id: 'vejle',
		cityId: 'vejle',
		opened: '20251218',
		closed: null,
		address: 'Koldingvej 17, 7100 Vejle',
		coordinates: {lat: '55.70254', lng: '9.52952'},
	}],
	rooms: [
		Object.assign({}, roomTemplate, {
			id: 'secret-of-time',
			name: {da: 'Tidens Hemmelighed', en: 'Tidens Hemmelighed'},
			minutes: 90,
			minPlayers: 2,
			maxPlayers: 6,
			locations: [{
				locationId: 'vejle',
				opened: '20251218',
				closed: null,
				rooms: 1
			}]
		})
	]
});


export {venueData};